import React from "react";
import { Box, Chip, Typography } from "@mui/material";

type Props = {
  meta?: any;
  onClear?: (key: string) => void;
};

export default function FilterContextBar({ meta, onClear }: Props) {
  if (!meta) return null;

  const items = [
    { key: "period", label: "Period", value: meta.periodCode },
    { key: "cycle", label: "Cycle", value: meta.cycleCode },
    { key: "scenario", label: "Scenario", value: meta.scenarioCode },
    { key: "costcenter", label: "Cost Center", value: meta.costCenterCode },
    { key: "location", label: "Location", value: meta.locationCode },
    { key: "asofdate", label: "As of", value: meta.asOfDate },
  ].filter((x) => x.value !== null && x.value !== undefined && x.value !== "");

  return (
    <Box
      sx={{
        mt: 1.5,
        display: "flex",
        alignItems: "center",
        gap: 1,
        flexWrap: "wrap",
      }}
    >
      <Typography sx={{ fontSize: 12, color: "#66788A", fontWeight: 700 }}>
        Context:
      </Typography>

      {items.map((x) => {
        const clearable = ["costcenter", "location", "cycle"].includes(x.key);

        return (
          <Chip
            key={x.key}
            size="small"
            label={`${x.label}: ${x.value}`}
            onDelete={clearable ? () => onClear?.(x.key) : undefined}
            sx={{
              bgcolor: "#F3F8FC",
              color: "#163A5F",
              border: "1px solid #CFE3F4",
              fontWeight: 600,
            }}
          />
        );
      })}
    </Box>
  );
}